import { AppRouteProps } from "@harea/component";
import React from "react";

const AbsenceUserDetailsContainer = React.lazy(() => import('./containers/AbsenceUserDetailsContainer'))
export const AbsenceUserDetailsRoutes: Array<AppRouteProps> = [
    {
        path: 'absences',
        title: 'Harea.User.Absences.title',
        element: <AbsenceUserDetailsContainer />
    }
]
